type IconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const ScenicViewsIcon = ({ size = 18, color = 'currentColor', className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <polygon points="12 2 2 22 22 22" />
    <polygon points="17 8 13 22 21 22" />
  </svg>
);
